import { COMMUNITY_TAGS, MAP_PINS } from "@/data/content";
import Icon from "@/components/Icon";

export default function CommunitiesSection() {
  return (
    <section className="section communities" id="communities" data-testid="communities-section">
      <div className="container communities__grid">
        <div className="communities__copy">
          <h2 className="communities__title">Connected Across Communities</h2>
          <p className="communities__sub">Expanding access. Strengthening lives. Nationwide.</p>
          <p className="communities__text">
            Proactive UMS supports patients, providers, families, employers and communities across the
            United States with scalable, technology-driven healthcare solutions.
          </p>
          <div className="communities__tags">
            {COMMUNITY_TAGS.map((t) => (
              <div className="communities__tag" key={t.title}>
                <span className="communities__tag-ic"><Icon name={t.icon} size={16} /></span>
                <div><strong>{t.title}</strong><em>{t.sub}</em></div>
              </div>
            ))}
          </div>
        </div>

        <div className="communities__map">
          <img src="/assets/us-map.png" alt="United States coverage" className="communities__map-img" />
          {MAP_PINS.map((p, i) => (
            <span key={i} className="map-pin" style={{ left: `${p.x}%`, top: `${p.y}%`, animationDelay: `${i * 0.25}s` }}>
              <Icon name="Heart" size={10} />
            </span>
          ))}
          <div className="communities__impact">
            <strong>Nationwide Impact</strong>
            <span>Healthier People</span>
            <span>Stronger Communities</span>
            <span>Brighter Tomorrows</span>
          </div>
        </div>

        <div className="communities__child">
          <img src="/assets/communities-child.png" alt="A hopeful child" className="communities__child-img" />
          <span className="communities__script">A healthier<br/>tomorrow<br/>lives here.</span>
        </div>
      </div>
    </section>
  );
}
